<template>
  <div class="rank_page">
    <div class="list_wrapper">
      <div class="list">
        <span class="rank">1</span>
        <strong class="user_name">只为今生</strong>
      </div>
      <div class="list">
        <span class="rank">2</span>
        <strong class="user_name">只为今生</strong>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:"myRanking"
}
</script>

<style lang="stylus">
.rank_page
  padding-bottom:60px
  background:#fff
  .list
    padding:20px 30px
    border-bottom:1px solid #f0f0f0
    /*px*/
    display:flex
    background:#fff
    .rank
      flex:0 0 40px
      font-size:30px
      color:#333
    .user_name
      font-size:30px
      color:#999
      flex:1
      text-align:center
      line-height:40px
</style>



// WEBPACK FOOTER //
// src/components/userCenter/myRanking.vue